var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED6C2D",
    d: "M7 10.154q.229 0 .384-.155a.52.52 0 0 0 .155-.384.52.52 0 0 0-.155-.383A.52.52 0 0 0 7 9.077a.52.52 0 0 0-.384.155.52.52 0 0 0-.154.383q0 .229.154.384a.52.52 0 0 0 .384.155m-.5-2.436h1v-4h-1zm.501 5.615a6.2 6.2 0 0 1-2.47-.498A6.4 6.4 0 0 1 2.52 11.48a6.4 6.4 0 0 1-1.354-2.01A6.2 6.2 0 0 1 .666 7q0-1.315.5-2.47A6.4 6.4 0 0 1 2.518 2.52a6.4 6.4 0 0 1 2.01-1.354A6.2 6.2 0 0 1 7 .666q1.314 0 2.47.5 1.156.498 2.011 1.353t1.354 2.01q.5 1.156.5 2.47t-.5 2.47a6.4 6.4 0 0 1-1.353 2.011 6.4 6.4 0 0 1-2.01 1.354 6.2 6.2 0 0 1-2.47.5"
  })));
};
export default SvgError;